import { Injectable } from '@angular/core';

import { environment } from '@wms/app';
import { NotificationService, ProjectService, WmHttpService } from "@wms/services";
import { runtimeEventManager } from "@wm/core";

const cache = new Map<string, string>();

@Injectable({
  providedIn: 'root'
})
export class AppResourceManagerService {
  private pendingRequests: Map<string, Promise<any>> = new Map();

    get(url: string, useCache?: boolean, responseType?: string): string | any {
      const cachedResponse = cache.get(url);
      if (cachedResponse && useCache) {
        return Promise.resolve(cachedResponse);
      }
      let pendingReq = this.pendingRequests.get(url);
      if (pendingReq) {
        return pendingReq;
      }
      let $promise = this.$http.get(url, {responseType: responseType}).then((response: any) => {
        this.pendingRequests.delete(url);
          if (typeof (response) === 'string' && !responseType) {
            response = JSON.parse(response);
          }
          if (useCache) {
            cache.set(url, response);
            if (!url.startsWith(environment.SERVICES_BASE_PATH)) {
              url = environment.SERVICES_BASE_PATH + url;
            }
            cache.set(url, response);
          }
          return response;
        }, (errResponse) => {
        if (errResponse.error) {
          this.notificationService.show("error", 'Error', errResponse.error);
        }
        this.pendingRequests.delete(url);
        return Promise.reject();
      });
      this.pendingRequests.set(url, $promise);
      return $promise;
    }

    public removeUrlCache(pageName: string) {
      const entry: Array<any> | undefined = [...cache].find(([k, v]) => k.endsWith(this.projectService.getProjectId() + '/pages/' + pageName + '/page.min.json'));
      const removekey: string = entry ? entry[0] : '';
      if (removekey) {
        cache.set(removekey, '');
      }
    }

    public clearCache() {
        cache.clear();
    }

    constructor(private $http: WmHttpService, private projectService: ProjectService, private notificationService: NotificationService) {
      runtimeEventManager.setService('AppResourceManagerService', this);
    }
}
